import { render, staticRenderFns } from "./CodingSchemaEdit.vue?vue&type=template&id=12f3136b&"
import script from "./CodingSchemaEdit.vue?vue&type=script&lang=js&"
export * from "./CodingSchemaEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports